import { PulseItem } from "./types";

export const REQUEST_PULSE_SUCCESS = "REQUEST_PULSE_SUCCESS";
export const SET_PLAYBACK_DURATION = "SET_PLAYBACK_DURATION";
export const REMOVE_PLAYBACK_DURATION = "REMOVE_PLAYBACK_DURATION";
export const FINISH_PULSE_CONTENT = "FINISH_PULSE_CONTENT";
export const END_PULSE_CONTENT = "END_PULSE_CONTENT";

export interface RequestPulseSuccessAction {
  type: typeof REQUEST_PULSE_SUCCESS;
  payload: {
    pulseItem: PulseItem;
  };
}

export interface SetPlaybackDurationAction {
  type: typeof SET_PLAYBACK_DURATION;
  payload: {
    pulseItemKey: string;
    durationMs: number;
  };
}

export interface RemovePlaybackDurationAction {
  type: typeof REMOVE_PLAYBACK_DURATION;
  payload: {
    pulseItemKey: string;
  };
}

export interface FinishPulseContentAction {
  type: typeof FINISH_PULSE_CONTENT;
  payload: {
    pulseItemKey: string;
  };
}

export interface EndPulseContentAction {
  type: typeof END_PULSE_CONTENT;
  payload: {
    pulseItemKey: string;
  };
}
export type PulseAction =
  | RequestPulseSuccessAction
  | SetPlaybackDurationAction
  | RemovePlaybackDurationAction
  | FinishPulseContentAction
  | EndPulseContentAction;

export const requestPulseSuccess = (
  pulseItem: PulseItem
): RequestPulseSuccessAction => ({
  type: REQUEST_PULSE_SUCCESS,
  payload: { pulseItem },
});

export const setPlaybackDuration = ({
  pulseItemKey,
  durationMs,
}: {
  pulseItemKey: string;
  durationMs: number;
}): SetPlaybackDurationAction => ({
  type: SET_PLAYBACK_DURATION,
  payload: { pulseItemKey, durationMs },
});

export const removePlaybackDuration = (
  pulseItemKey: string
): RemovePlaybackDurationAction => ({
  type: REMOVE_PLAYBACK_DURATION,
  payload: { pulseItemKey },
});

export const finishPulseContent = (
  pulseItemKey: string
): FinishPulseContentAction => ({
  type: FINISH_PULSE_CONTENT,
  payload: { pulseItemKey },
});

export const endPulseContent = (
  pulseItemKey: string
): EndPulseContentAction => ({
  type: END_PULSE_CONTENT,
  payload: { pulseItemKey },
});
